/**
 * LA MAQUINARIA Y LAS LESIONES DE LA FICHA, SIN CONTRADICCIONES (14-10, RUT-15).
 *
 * La pestaña Entreno dejaba marcar «Ninguno» junto con Mancuernas y TRX, y añadir dos veces
 * la misma lesión. De ahí lee quien prepara la rutina (y la IA que la genera). La misma regla
 * está en el servidor al guardar (`models/user.lista_sin_contradicciones`); aquí es para que
 * la pantalla no enseñe lo que no se va a guardar.
 */
import { sinTildes } from './sinTildes';

export const SIN_MATERIAL = 'ninguno';

/** Marca o desmarca un material. «Ninguno» desmarca los demás, y cualquier otro lo desmarca a él. */
export function alternarMaterial(lista, valor) {
    const actual = lista || [];
    if (actual.includes(valor)) return actual.filter((x) => x !== valor);
    if (valor === SIN_MATERIAL) return [SIN_MATERIAL];
    return [...actual.filter((x) => x !== SIN_MATERIAL), valor];
}

const igual = (a, b) => sinTildes(a).trim().replace(/\s+/g, ' ') === sinTildes(b).trim().replace(/\s+/g, ' ');

/** ¿Está ya esa lesión en la lista? Sin mirar mayúsculas, tildes ni espacios de más. */
export const yaEstaLaLesion = (lista, texto) => (lista || []).some((l) => igual(l, texto));

/** La lista con la lesión añadida; la misma lista si estaba ya o no hay nada que añadir. */
export function anadirLesion(lista, texto) {
    const limpio = String(texto || '').trim().replace(/\s+/g, ' ');
    if (!limpio || yaEstaLaLesion(lista, limpio)) return lista || [];
    return [...(lista || []), limpio];
}
